import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { Router } from '@angular/router' ;
import { environment } from '../../../environments/environment';

import { UserModel } from '../../main/Models';
import { globalData } from 'src/app/main/Models/global.model';

@Injectable()
export class ApiService {

  constructor(private http: HttpClient,
              private router: Router,
              private gd: globalData) {
  }

  public isConnected(): boolean
  {
    let authToken = localStorage.getItem('access_token');
    return (authToken != null && authToken != "undefined");
  }

  public connect(username, password)
  {
    let connectUrl = environment.baseUrl + '/oauth';
    let params = {
      client_id: 'miiar',
      username: username,
      password: password,
      grant_type: 'password'
    };

    return new Promise((resolve, reject) => {
      this.http.post(connectUrl, params)
        .subscribe(
          response => {
            this.recordTokens(response).then(() => resolve(1));
          },
          error => {
            resolve(0);
          }
        );
      });
  }
  public getUserData() {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem('userData') != undefined) {
        resolve(JSON.parse(localStorage.getItem('userData')));
        return;
      }

      this.getFromServer('user/me')
        .then(s => s.subscribe(
          (response: any) => {
              localStorage.setItem('userData', JSON.stringify(response));
              resolve(JSON.parse(localStorage.getItem('userData')));
              return;
          },
          err => reject(err) ),
        );
    });
  }

  get connectedUser(): UserModel
  {
    if (this.gd.connectedUser == undefined)  {
      this.gd.connectedUser = new UserModel(null);
      this.getUserData().then(
        userData => {
          this.gd.connectedUser = new UserModel(userData);
        }
      );
    }
    return this.gd.connectedUser;
  }

  public disconnect()
  {
    localStorage.clear();
    this.router.navigate(['']);
    window.location.reload();
  }
  public exit()
  {
    return this.verifHeaders().then((options) => {

      let oauthUrl = environment.baseUrl + '/disconnect';
      return this.http.get(oauthUrl, options)
        .pipe(
            catchError(this.handleError)
          )
        .subscribe((response: any) => {
          this.disconnect();
        });
    });
  }

  protected recordTokens(response)
  {
    localStorage.clear();

    return new Promise((resolve, reject) => {
      localStorage.setItem('access_token', response['access_token']);
      localStorage.setItem('refreshToken', response['refresh_token']);
      let refreshTime = new Date();
      refreshTime.setSeconds(refreshTime.getSeconds() + response['expires_in']);
      localStorage.setItem('refreshTime', refreshTime.toString());

      setTimeout(() => { resolve(true); }, 500);
    });
  }

  protected refreshIfnecessary()
  {
    return new Promise((resolve, reject) => {
      let rT = localStorage.getItem('refreshTime');
            if (rT) {
        let currentDate = new Date();
        let refreshTime = new Date(rT);
        if (currentDate >= refreshTime) {

          let refreshUrl = environment.baseUrl + '/oauth';
          let refreshParams = {
            client_id: 'miiar',
            grant_type: 'refresh_token',
            refresh_token: localStorage.getItem('refreshToken')
          };
          this.http.post(refreshUrl, refreshParams)
            .subscribe(
              response => {
                this.recordTokens(response)
                  .then(() => {

                    resolve(true);
                  } );
              },
              err => {
                console.log('refresh -> err', err);
                reject();
              });
        } else {

          resolve(true);
        }
      } else {

        reject();
      }
    });
  }

  public verifHeaders(isText= false)
  {
    return new Promise((resolve, reject) => {

      this.refreshIfnecessary().then(
        () => { // resolve

        let authToken = localStorage.getItem('access_token');
        if (authToken) {

           let HH;
           let RT;
          if (isText) {
              HH = new HttpHeaders()
              .set('Content-type', 'text/html')
              .set('Accept', 'text/html, application/json, application/problem+json')
              .set('Access-Control-Allow-Origin', '*')
              .set('responseType', 'text')
              .set("Authorization", "Bearer " + authToken );
              RT = 'text';
          } else {
              HH = new HttpHeaders()
              .set('Content-type', 'application/json')
              .set('Accept', 'application/json, application/problem+json')
              .set('Access-Control-Allow-Origin', '*')
              .set("Authorization", "Bearer " + authToken );
              RT = 'json';
          }
          let options = { headers: HH, responseType: RT };

          resolve(options);

        } else {
            this.disconnect();
            reject();
          }
        },
        () => { // reject
            this.disconnect();
          reject();
        });
    });
  }

  public getFromServer(entities, params= null)
  {
    return this.verifHeaders().then((options) => {

      let getUrl = environment.apiBaseUrl + '/' + entities;
      if (params) getUrl += '?' + params;
      return this.http.get(getUrl, options)
          .pipe(
            catchError(this.handleError)
          );
    });
  }

  public getAllFromServer(entities, params= '?', embeddedEntities= null): Promise<Array<any>>
  {
    if (embeddedEntities === null) embeddedEntities = entities;
    return new Promise( (resolve, reject) => {
      let elements = [];
      let listPromises = [];
      let page = 1;
      let totalPage = 1;

      this.getFromServer(entities, params)
        .then(s => s.subscribe((response: any) => {

          elements = response._embedded[embeddedEntities];
          totalPage = response.page_count;

          page++;
          while (page <= totalPage) {
            let pagedParams = params + '&page=' + page;

            listPromises.push( new Promise( (resolve2, reject2) => {
              this.getFromServer(entities, pagedParams)
              .then(s => s.subscribe((response: any) => {
                elements = elements.concat(response._embedded[embeddedEntities]);

                resolve2(true);
              }));
            }) );
            page++;
          }

          Promise.all(listPromises).then(() => {

            resolve(elements);
          });
      }));



    });
  }

  public getOneFromServer(entity, id, params= null)
  {
    return this.verifHeaders().then((options) => {
      let getUrl = environment.apiBaseUrl + '/' + entity + '/' + id;
      if (params) getUrl += '?' + params;
      return this.http.get(getUrl, options)
        .pipe(
          catchError(this.handleError)
        );
    });
  }



  public getTextFromServer (entity, id, fromAPI= false, params= null) {
    return this.verifHeaders(true).then((options) => {

      let getUrl = fromAPI ? environment.apiBaseUrl : environment.baseUrl;
      getUrl += '/' + entity + '/' + id;

      if (params)
          getUrl += '?' + params;
      return this.http.get(getUrl, options)
      .pipe(
        catchError(this.handleError)
      );
    });
  }

  public UpdateToServer(entities, model)
  {
    return this.verifHeaders().then((options) => {
      let saveUrl = environment.apiBaseUrl + '/' + entities + '/' + model.id;
      return this.http.patch(saveUrl, this.filter(model), options)
          .pipe(
            catchError(this.handleError)
          );
    });
  }

  public UpdateListToServer(entities, models)
  {
    return this.verifHeaders().then((options) => {
      let saveUrl = environment.apiBaseUrl + '/' + entities;
      return this.http.patch(saveUrl, this.filter(models), options)
          .pipe(
            catchError(this.handleError)
          );
    });
  }

  public SaveToServer(entities, model)
  {
    return this.verifHeaders().then((options) => {
      let saveUrl = environment.apiBaseUrl + '/' + entities;
      return this.http.post(saveUrl, this.filter(model), options)
        .pipe(
          catchError(this.handleError)
        );
    });
  }

  public PostToServer(url, data)
  {

    let postUrl = environment.baseUrl + '/' + url;
    return this.http.post(postUrl, data)
      .pipe(
        catchError(this.handleError)
      );

  }

  public DeleteFromServer(entities, model)
  {
    return this.verifHeaders().then((options) => {
      let deleteUrl = environment.apiBaseUrl + '/' + entities + '/' + model.id;
      return this.http.delete(deleteUrl, options)
        .pipe(
          catchError(this.handleError)
        );
    });
  }


  public filter(model)
  {
    let r = {};
    for (let p in model) {
      if (p != 'id') r[p] = model[p];
    }
    return JSON.stringify(r);
  }

  public createHttpParams(model)
  {
    let body = new HttpParams();
    for (let p in model) {
      if (p != 'id') body.set(p, model[p]);
    }
    return body;
  }


  public createParams(memberOf= null, type: any= 'ismemberof', ordered= false, orderBy= "ordre", orderDir= 'asc')
  {
    let stringParams = '';
    let filterCount = 0;

    if (memberOf) {
      for (let p in memberOf) {
        let t = type;
        if (typeof type == 'object') t = type[filterCount];
        stringParams += '&filter[' + filterCount + '][type]=' + t
                        + '&filter[' + filterCount + '][field]=' + p;
        if (type != 'in')
           stringParams += '&filter[' + filterCount + '][value]=' + memberOf[p];
         else {
           for (let i = memberOf[p].length - 1; i >= 0; i--) {
             stringParams += '&filter[' + filterCount + '][values][' + i + ']=' + memberOf[p][i];
           }
         }
        filterCount++;
      }
      if (ordered) {
          // ORDER BY ordre ASC
          stringParams += '&order-by[0][type]=field'
                          + '&order-by[0][field]=' + orderBy
                          + '&order-by[0][direction]=' + orderDir;
          }
    }
    return stringParams;
  }

  public simpleGet(url, withBase= true)
  {
    if (withBase) url = environment.baseUrl + '/' + url;
    return this.http.get(url, {responseType: 'text'});
  }

  public urlExist(url, withBase= true)
  {
    if (withBase) url = environment.baseUrl + '/' + url;
    return this.http.head(url, {responseType: 'text'});
  }

  // Implement a method to handle errors if any
  private handleError(err: HttpErrorResponse | any) {
    console.error('An error occurred', err);
    return err;
    // return Observable.throw(err.message || err);
  }

  public hasConnexion = true;

  public testConnexion()
  {
    this.urlExist('textconnexion.flag').subscribe(
         resp => { this.hasConnexion = true; },
         err => { this.hasConnexion = false; });
  }
}

